module.exports = __webpack_public_path__ + "img/07.0a961f59.jpg";